import { BasicOptionModel, IBasicOption } from "@core/models";

export const mockQualities = [
  { [IBasicOption.id]: 2, [IBasicOption.name]: "Compr\u00e9hensif" },
  { [IBasicOption.id]: 3, [IBasicOption.name]: "Bon developeur" },
].map((o) => new BasicOptionModel(o));

export const mockOrigins = [
  { [IBasicOption.id]: 1, [IBasicOption.name]: "Un(e) ami(e) / Coll\u00e8gue" },
  { [IBasicOption.id]: 2, [IBasicOption.name]: "App Store / Play Store" },
  { [IBasicOption.id]: 3, [IBasicOption.name]: "Google" },
  { [IBasicOption.id]: 4, [IBasicOption.name]: "R\u00e9seaux sociaux" },
  { [IBasicOption.id]: 5, [IBasicOption.name]: "Sites d\u2019offres d\u2019emploi" },
  { [IBasicOption.id]: 6, [IBasicOption.name]: "TV, presse, publicit\u00e9" },
  { [IBasicOption.id]: 7, [IBasicOption.name]: "Un(e) client(e)" },
  { [IBasicOption.id]: 8, [IBasicOption.name]: "Equipe Extracadabra" },
  { [IBasicOption.id]: 9, [IBasicOption.name]: "Autre" },
].map((o) => new BasicOptionModel(o));

export const mockSkills = [
  { [IBasicOption.id]: 28, [IBasicOption.name]: "Cuisine alg\u00e9rienne" },
  { [IBasicOption.id]: 9, [IBasicOption.name]: "Adobe Lightroom" },
  { [IBasicOption.id]: 10, [IBasicOption.name]: "Adobe Photoshop" },
  { [IBasicOption.id]: 8, [IBasicOption.name]: "Adobe indesign" },
  { [IBasicOption.id]: 7, [IBasicOption.name]: "Adobe illustrator" },
  { [IBasicOption.id]: 11, [IBasicOption.name]: "Adobe XD" },
];

export const mockSuggestedSkills = [
  { [IBasicOption.id]: 65536, [IBasicOption.name]: "Cocktails base et international" },
  { [IBasicOption.id]: 65537, [IBasicOption.name]: "Chef de Cuisine" },
];
